import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { getPermissions } from './check';
import { Permission, PermissionKey, PERMISSIONS } from './constants';

export type PermissionsMap = Record<Permission, boolean>;

/**
 * Hook que retorna o mapa de permissões do usuário logado.
 * Usar nos componentes que precisam condicionar UI ou lógica.
 */
export function usePermissions(): PermissionsMap {
  const user = useSelector((state: RootState) => state.auth.user);
  return getPermissions(user);
}

/**
 * Helper para checar uma permissão específica.
 */
export function usePermission(key: PermissionKey): boolean {
  const permissions = usePermissions();
  return !!permissions[PERMISSIONS[key]];
}
